// extracted by mini-css-extract-plugin
export default {"modelsGallery":"bstlKdVGPvSaBasO_HoA","container":"EvHUYN_CuNBRokFyQkz4","slider":"iJ3m6qxgZ1H_8x4jZnYw"};